<template>
  <a :href="csvData" :download="filename">{{label}}</a>
</template>

<script>
  function escapeCSVValue(val) {
    let escapedVal = val || ''
    if (escapedVal.indexOf(',') > -1) {
      escapedVal = escapedVal.replace(/"/g, '""')
      escapedVal = '"' + escapedVal + '"'
    }
    return escapedVal
  }

  function generateCSVString(headers, rows) {
    let csvString = headers.map(header => escapeCSVValue(header)).join(',').concat('\r\n')
    rows.forEach(row => {
      csvString += row.map(val => escapeCSVValue(val)).join(',').concat('\r\n')
    })
    return csvString
  }

  export default {
    name: 'ExportToCSVButton',
    props: {
      label: {
        type: String,
        default: 'Export'
      },
      filename: {
        type: String,
        default: 'export.csv'
      },
      headers: {
        type: Array,
        required: true
      },
      rows: {
        type: Array,
        required: true
      }
    },
    computed: {
      csvData() {
        return `data:attachment/csv,${encodeURIComponent(generateCSVString(this.headers, this.rows))}`
      }
    }
  }
</script>
